var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 22,
    viewBox: "0 0 28 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.5157 1.10149C5.12518 0.710963 4.49201 0.710963 4.10149 1.10149C3.71096 1.49201 3.71096 2.12518 4.10149 2.5157L12.5873 11.0015L4.10247 19.4863C3.71194 19.8768 3.71194 20.51 4.10247 20.9005C4.49299 21.291 5.12616 21.291 5.51668 20.9005L14.0015 12.4157L22.4863 20.9005C22.8768 21.291 23.51 21.291 23.9005 20.9005C24.291 20.51 24.291 19.8768 23.9005 19.4863L15.4157 11.0015L23.9015 2.5157C24.292 2.12518 24.292 1.49201 23.9015 1.10149C23.5109 0.710963 22.8778 0.710963 22.4872 1.10149L14.0015 9.58726L5.5157 1.10149Z",
    fill: "#282624"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.c721e0ea502bf09722369259b0abfe71.svg";
export { ForwardRef as ReactComponent };